import React, { Component } from "react";

import { Row, Col } from "react-bootstrap";

export default class extends Component {

  render() {
    return (
      <Row>
        <Col mdOffset={2} md={8}>
            <div class="alert alert-danger">
                <strong>Error!</strong> Server returned error code: 200
            </div>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js